import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
// import axios from 'axios';
import QRQinectAPI from '../QRQinectAPI';

class CreateQRCodes extends Component {
    constructor(props) {
        super(props);
        this.state = {
            lastUpdated: Date.now(),
            showCreationModal: false,
            QRCodeOptions: {},
            currentBusinessQR: null,
            showPreview: false,
            Buyer: { Name: 'Name' },
            Codes: [],
            ViewableCodes: [],
            ShowComponent: false,
            loading: true,
            Switch: { height: 21, width: 48, primaryColor: "#027473", secondaryColor: "#AFD8C9" }
        };
        this.state.apiParameters = {
            // QRCreation
            IsBusinessQRCode: "true",
            BuyerID: "",
            QRCode: "",
            BusinessQRName: "",
            BackgroundShape: "",
            ForegroundColor: "#000000",
            Campaign: 652,
            EyeType: "Standard",
            EyeShape: "Square",
            CellShape: "Circle",
            ClientName: "",
            ClientEmail: "",
            ClientMessage: ""
        }
        this.monthArray = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"];
        // used to search/filter
        this.searchTerm = "";
        // current sort option
        this.sortedBy = "";
    }
    componentDidMount() {
        // get the valid QRCode shape options
        QRQinectAPI.getQRCodeBackgroundShapes()
            .then((response) => {
                this.setState({ QRCodeOptions: response.data });
            })
            .catch((error) => {
                console.log(error);
            });
        this.reload();
    }
    reload = () => {
        // we need to get the list of qrcodes for the provided buyer.
        QRQinectAPI.getBuyerBusinessCodes(this.props.token)
            .then((response) => {
                // update the dates in the Codes object (so we can filter on them)
                if (response.data.BusinessCodes) {
                    for (let i = 0; i < response.data.BusinessCodes.length; i++) {
                        response.data.BusinessCodes[i].DateAddedFormatted = this.formatDate(response.data.BusinessCodes[i].DateAdded);
                    }
                }
                this.updateAPIStateValue("BuyerID", response.data.Buyer.ID);
                this.setState({ Buyer: response.data.Buyer, currentBusinessQR: null, NumBusinessCodes: response.data.NumBusinessCodes, NumBusinessCodesAllowed: response.data.NumBusinessCodesAllowed, Codes: response.data.BusinessCodes, ViewableCodes: response.data.BusinessCodes, showMessageDialog: false, message: null, ShowComponent: true, loading: false });
            })
            .catch((error) => {
                console.log(error);
                this.setState({ ShowComponent: true, error: true, errorMessage1: "It looks like you may be using an invalid or expired link to view your account.", errorMessage2: "", loading: false })
            });
            this.setState({lastUpdated: Date.now()});
    }
    formatDate = (dateString) => {
        if (dateString === "0") {
            return "n/a";
        }
        let formattedDate = new Date(dateString);
        let hour = formattedDate.getHours();
        let period = 'am';
        if (hour === 12) {
            period = 'pm';
        } else if (hour > 12) {
            hour -= 12;
            period = 'pm';
        }
        let minutes = formattedDate.getMinutes();
        if (minutes < 10) {
            minutes = "0" + minutes;
        }
        return this.monthArray[formattedDate.getMonth()] + ' ' + formattedDate.getDate() + ' ' + formattedDate.getFullYear() + ' ' + hour + ':' + minutes + ' ' + period;
    }
    cancelHandler = () => {
        this.setState({ selectedQRCodeGUID: null, showModalDialog: false, showRenameDialog: false, showSearchModal: false, showSortModal: false, showSMSOptionsModal: false });
    }

    updateAPIStateValue(object, newValue) {
        let stateCopy = Object.assign({}, this.state);
        stateCopy['apiParameters'][object] = newValue;
        this.setState(stateCopy);
    }
    handleDataChange = (event) => {
        let fieldName = event.target.getAttribute('data-fieldname');
        this.updateAPIStateValue(fieldName, event.target.value);
    }
    editQRCode = (qrCode) => {
        this.updateAPIStateValue("BusinessQRName", qrCode.BusinessName);
        this.updateAPIStateValue("QRCode", qrCode.GUID);
        this.setState({ showCreationModal: true });
    }
    prepNewQRCode = () => {
        this.updateAPIStateValue("BusinessQRName", "");
        this.updateAPIStateValue("QRCode", "");
    }
    sendClientEmail = () => {
        QRQinectAPI.sendBusinessQRCodeToClient(this.state.apiParameters)
            .then((response) => {
                // show message modal
                this.setState({ showEmail: false, showMessageDialog: true, message: "Your email has been sent." });
                console.log(response);
            })
            .catch((error) => {
                this.setState({ showMessageDialog: true, message: "Unable to send your QRCode, please try again." });
                console.log(error);
            })
            .finally(() => {
            });
    }
    CreateQRCode = () => {
        this.setState({ loading: true });
        QRQinectAPI.createBusinessQRCode(this.state.apiParameters)
            .then((response) => {
                console.log(response);
                // show message modal
                window.location.reload(true);
            })
            .catch((error) => {
                this.setState({ showMessageDialog: true, message: "Unable to create your QRCode, please try again." });
                console.log(error);
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    }


    // not ideal, doesn't search viewable information, just data. Won't include dates properly, etc.
    searchQRCodes = () => {
        let tmpArray = [], i, key;
        for (i = 0; i < this.state.Codes.length; i++) {
            for (key in this.state.Codes[i]) {
                if ((this.state.Codes[i][key] + '').toLowerCase().indexOf(this.searchTerm.toLowerCase()) !== -1) {
                    tmpArray.push(this.state.Codes[i]);
                }
            }
        }
        this.setState({ ViewableCodes: tmpArray, showSearchModal: false });
    }
    sortQRCodes = (type) => {
        switch (type) {
            case "name":
                this.sortedBy = "Name";
                this.setState({ ViewableCodes: this.state.ViewableCodes.sort((a, b) => { return ('' + a.BusinessName).localeCompare(b.BusinessName); }) });
                break;
            case "created":
                this.sortedBy = "Added";
                this.setState({ ViewableCodes: this.state.ViewableCodes.sort((a, b) => { return ('' + b.DateAdded).localeCompare(a.DateAdded); }) });
                break;
            default:
                this.sortedBy = "";
                break;
        }
        this.setState({ showSortModal: false });
    }
    handleSearchTermChange(event) {
        this.searchTerm = event.target.value;
    }
    renderEmailModal = () => {
        if (this.state.showEmail) {
            return (
                <React.Fragment>
                    <div onClick={() => { this.setState({ showEmail: false }) }} style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px' }}>
                    </div>
                    <div style={{ backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '15px', width: 'calc(100% - 15px)', maxWidth: '600px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '100%' }}>
                            Send this QRCode to your client.
                        </div>
                        <div className="input-field">
                            <label htmlFor="ClientName">Client Name</label>
                            <input id="ClientName" type="text" data-fieldname="ClientName" className="form-control" onChange={this.handleDataChange} />
                        </div>
                        <div className="input-field">
                            <label htmlFor="ClientEmail">Client Email Address</label>
                            <input id="ClientEmail" type="text" data-fieldname="ClientEmail" className="form-control" onChange={this.handleDataChange} />
                        </div>
                        <div className="input-field">
                            <label htmlFor="ClientMessage">Message</label>
                            <input id="ClientMessage" type="text" data-fieldname="ClientMessage" className="form-control" onChange={this.handleDataChange} />
                        </div>
                        <div>
                            <a className="button" onClick={() => { this.setState({ showEmail: false }) }} style={{ display: 'inline-block', backgroundColor: '#666' }}>CANCEL</a>
                            <a className="button" onClick={this.sendClientEmail} style={{ display: 'inline-block' }}>SEND</a>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
    }
    renderPreviewModal = () => {
        if (this.state.showPreview) {
            return (
                <React.Fragment>
                    <div onClick={() => { this.setState({ showPreview: false }) }} style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px' }}>
                    </div>
                    <div style={{ backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '15px', width: 'calc(100% - 15px)', maxWidth: '600px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '100%' }}>
                            <p>{this.state.currentBusinessQR.BusinessName}</p>
                        </div>
                        <div>
                            <img style={{ width: "100%", height: "100%" }} src={this.state.currentBusinessQR.FilePath + "?" + this.state.lastUpdated} alt="QR Code Preview" />
                        </div>
                    </div>
                </React.Fragment>
            );
        }
    }
    renderCodes = () => {
        if (this.state.error) {
            return (
                <div style={{ textAlign: 'center' }}>
                    <p>{this.state.errorMessage1}</p>
                    <p>{this.state.errorMessage2}</p>
                </div>
            );
        } else if (this.state.ViewableCodes) {
            return (
                <div className="font_regular">
                    {this.state.ViewableCodes.map((row, idx) => {
                        return (
                            <React.Fragment key={idx}>
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '100%' }}>
                                    <div style={{ width: '100%' }}>
                                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                            <span>
                                                <div><span className="font_medium">Name:</span> {row.BusinessName}</div>
                                                <div><span className="font_medium">Reference ID:</span> {row.GUID}</div>
                                                <div><span className="font_medium">Created:</span> {row.DateAddedFormatted}</div>
                                            </span>
                                            <span onClick={() => this.setState({ currentBusinessQR: row, showPreview: true })} style={{ width: "63px", height: "63px", background: "center/contain no-repeat url(" + row.FilePath + "?" + this.state.lastUpdated + ")" }}></span>
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-around", width: "100%" }}>
                                            <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><a style={{ fontSize: 'xx-large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" onClick={() => this.setState({ currentBusinessQR: row, showPreview: true })}><i className="fa fa-qrcode"></i></a><div style={{ textAlign: "center" }}>Preview</div></span>
                                            <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><a style={{ fontSize: 'xx-large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" target="_blank" href={"/scan/" + row.GUID + "/view"}><i className="fa fa-eye"></i></a><div style={{ textAlign: "center" }}>Web Ex.</div></span>
                                            <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><a style={{ fontSize: 'xx-large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" target="_blank" href={QRQinectAPI.getDownloadQRURL(row.GUID)}><i className="fa fa-download"></i></a><div style={{ textAlign: "center" }}>Download</div></span>
                                            <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><a style={{ fontSize: 'xx-large', margin: '0 auto', color: this.state.Switch.primaryColor, cursor: 'pointer' }} onClick={() => { this.updateAPIStateValue("QRCode", row.GUID); this.setState({ currentBusinessQR: row, showEmail: true }) }}><i className="fa fa-envelope"></i></a><div style={{ textAlign: "center" }}>Email</div></span>
                                            <span style={{ display: "flex", flexDirection: "column", margin: "0 5px 0 5px" }}><a style={{ fontSize: 'xx-large', margin: '0 auto', color: this.state.Switch.primaryColor, cursor: 'pointer' }} onClick={() => this.editQRCode(row)}><i className="fa fa-pencil"></i></a><div style={{ textAlign: "center" }}>Edit</div></span>
                                        </div>
                                    </div>
                                </div>
                                <hr />
                            </React.Fragment>
                        );
                    })}
                </div>
            );
        }
        return null;
    }
    renderSpinner() {
        if (this.state.loading) {
            return (
                <React.Fragment>
                    <div style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px' }}>
                    </div>
                    <div style={{ backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '15px', width: 'calc(100% - 15px)', maxWidth: '600px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '100%' }}>
                            <p>Loading...</p>
                        </div>
                        <div className="fa-3x" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '100%' }}>
                            <i className="fa fa-circle-o-notch fa-spin"></i>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    renderSortModal() {
        if (this.state.showSortModal) {
            return (
                <React.Fragment>
                    <div onClick={this.cancelHandler} style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px' }}>
                    </div>
                    <div style={{ backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '15px', width: 'calc(100% - 15px)', maxWidth: '600px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '100%' }}>
                            <p>Sort By</p>
                        </div>
                        <div className="button" style={{ cusor: 'pointer' }} onClick={() => this.sortQRCodes("name")}>Name (A - Z)</div>
                        <div className="button" style={{ cusor: 'pointer' }} onClick={() => this.sortQRCodes("created")}>Date Created (New - Old)</div>
                        <div>
                            <a className="button" onClick={this.cancelHandler} style={{ display: 'inline-block', backgroundColor: '#666' }}>CANCEL</a>
                            {/* <a className="button" onClick={this.searchQRCodes} style={{ display: 'inline-block', width: '45%' }}>SUBMIT</a> */}
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    renderSearchModal() {
        if (this.state.showSearchModal) {
            return (
                <React.Fragment>
                    <div onClick={this.cancelHandler} style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px' }}>
                    </div>
                    <div style={{ backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '15px', width: 'calc(100% - 15px)', maxWidth: '600px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-around', width: '100%' }}>
                            <p>Search</p>
                        </div>
                        <div>
                            <input type="text" defaultValue={this.searchTerm} onChange={event => this.handleSearchTermChange(event)}></input>
                        </div>
                        <div>
                            <a className="button" onClick={this.cancelHandler} style={{ display: 'inline-block', width: '45%', marginRight: '10%', backgroundColor: '#666' }}>CANCEL</a>
                            <a className="button" onClick={this.searchQRCodes} style={{ display: 'inline-block', width: '45%' }}>SUBMIT</a>
                        </div>
                        <div>
                            <a onClick={() => { this.setState({ ViewableCodes: this.state.Codes, showSearchModal: false }); this.searchTerm = ""; }}>Clear Search and Show All Results</a>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    renderMessageModal() {
        if (this.state.showMessageDialog) {
            return (
                <React.Fragment>
                    <div onClick={() => { this.setState({ showMessageDialog: false }) }} style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px' }}>
                    </div>
                    <div style={{ backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '15px', width: 'calc(100% - 15px)', maxWidth: '600px' }}>
                        <div>
                            {this.state.message}
                        </div>
                        <div>
                            <a className="button" onClick={() => { this.setState({ showMessageDialog: false }) }} style={{ display: 'inline-block', backgroundColor: '#666' }}>BACK</a>
                        </div>
                    </div>
                </React.Fragment>
            );
        } else {
            return null;
        }
    }
    renderPersonalAccountButton = () => {
        let hasPersonalAccount = true;
        if (hasPersonalAccount) {
            return (
                <div>
                    <a className="button" onClick={() => { this.props.history.push("/report/" + this.props.token) }}>VIEW PERSONAL ACCOUNT</a>
                </div>
            );
        }
    }
    renderCreationModal = () => {
        if (this.state.showCreationModal) {
            return (
                <React.Fragment>
                    <div onClick={() => { this.setState({ showCreationModal: false }) }} style={{ width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,.5)', position: 'fixed', top: '0px', left: '0px' }}>
                    </div>
                    <div style={{ backgroundColor: '#fff', position: 'fixed', top: '50%', transform: 'translate(-50%, -50%)', left: '50%', padding: '15px', width: 'calc(100% - 15px)', maxWidth: '600px' }}>
                        <div className="input-field">
                            <label htmlFor="BusinessQRName">Client Name</label>
                            <input id="BusinessQRName" value={this.state.apiParameters.BusinessQRName} data-fieldname="BusinessQRName" onChange={this.handleDataChange} />
                        </div>
                        <div className="input-field">
                            <label htmlFor="BackgroundShape">QR Code Surrounding Shape</label>
                            <select style={{ display: 'block', backgroundColor: 'transparent', border: '0' }} data-fieldname="BackgroundShape" onChange={this.handleDataChange}>
                                <option value="">None (Standard QR Code)</option>
                                {Object.keys(this.state.QRCodeOptions).map((key) => {
                                    console.log(key);
                                    return (
                                        <option key={key} value={key}>{key}</option>
                                    );
                                })}
                            </select>
                        </div>
                        <div className="input-field">
                            <label htmlFor="ForegroundColor">QR Code Color</label>
                            <input style={{ width: '50px' }} id="" type="color" data-fieldname="ForegroundColor" value={this.state.apiParameters.ForegroundColor} className="form-control" onChange={this.handleDataChange} />
                            <input style={{ width: 'calc(100% - 60px)', paddingLeft: '10px' }} id="ForegroundColor" type="text" data-fieldname="ForegroundColor" value={this.state.apiParameters.ForegroundColor} className="form-control" onChange={this.handleDataChange} />
                        </div>
                        <div>
                            <a className="button" onClick={() => { this.setState({ showCreationModal: false }) }} style={{ display: 'inline-block', backgroundColor: '#666' }}>BACK</a>
                            <a className="button" onClick={this.CreateQRCode} style={{ display: 'inline-block' }}>CREATE</a>
                        </div>
                    </div>
                </React.Fragment>
            );
        }
    }
    renderNewCodeButton = () => {
        if (this.state.NumBusinessCodes < this.state.NumBusinessCodesAllowed) {
            return (
                <div>
                    <a className="button" onClick={() => { this.prepNewQRCode(); this.setState({ showCreationModal: true }) }}><i className="fa fa-plus"></i> NEW</a>
                </div>
            );
        }
    }
    renderHeader = () => {
        return (
            <React.Fragment>
                <div style={{ textAlign: 'center' }}>
                    <div>{this.state.Buyer.Name}</div>
                    <div style={{ textAlign: 'center' }}>
                        <a onClick={() => this.props.history.push('/accountPassword/update/' + this.props.token)}>Change Password</a>
                    </div>
                    {this.renderPersonalAccountButton()}
                    <div>You have created {this.state.NumBusinessCodes} of {this.state.NumBusinessCodesAllowed} Say More Business Codes</div>
                    {this.renderNewCodeButton()}
                </div>
            </React.Fragment>
        );
    }
    renderViewingOptions = () => {
        return (
            <React.Fragment>
                <div style={{ textAlign: 'center' }}>
                    <div>Viewing Options:</div>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-around", width: "100%" }}>
                        <span onClick={() => this.setState({ showSearchModal: true })} style={{ cursor: "pointer", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-search"></i></span><span> Search {this.searchTerm !== "" ? "(" + this.searchTerm + ")" : ""}</span></span>
                        <span onClick={() => this.setState({ showSortModal: true })} style={{ cursor: "pointer", margin: "0 5px 0 5px" }}><span style={{ fontSize: 'large', margin: '0 auto', color: this.state.Switch.primaryColor }} className="" ><i className="fa fa-sort-alpha-asc"></i></span><span> Sort {this.sortedBy !== "" ? "(" + this.sortedBy + ")" : ""}</span></span>
                    </div>
                </div>
                <hr />
            </React.Fragment>
        );
    }
    renderBody = () => {
        return (
            <React.Fragment>
                {this.renderViewingOptions()}
                {this.renderCodes()}
            </React.Fragment>
        );
    }
    render() {
        if (!this.state.ShowComponent) {
            if (this.state.loading) {
                return (
                    <React.Fragment>
                        {this.renderSpinner()}
                    </React.Fragment>
                );
            }
            return null;
        }
        return (
            <React.Fragment>
                <div className="login_register">
                    <div className="container">
                        <div className="entry">
                            <div className="head">
                                <div className="logoImage"></div>
                                {this.renderHeader()}
                                {this.renderBody()}
                            </div>
                        </div>
                    </div>
                </div>

                {this.renderSearchModal()}
                {this.renderSortModal()}
                {this.renderPreviewModal()}
                {this.renderEmailModal()}
                {this.renderCreationModal()}
                {this.renderMessageModal()}
                {this.renderSpinner()}
            </React.Fragment>
        );
    }
}
export default withRouter(CreateQRCodes);


// WEBPACK FOOTER //
// ./src/components/CreateQRCodes.js